import { compose, nest, withProps } from "recompose";
import * as hoc from "modules/user/auth/hoc";
import { isOnboardedCandidate } from "modules/user/auth/model";
import { Success } from "components/common/feedback";
import { Overlay } from "components/common/candidate";
import { candidate } from "routes/paths";

export default compose(
  hoc.authorized(isOnboardedCandidate),
  withProps({
    inviteLink: candidate.inviteFriend
  })
)(nest(Overlay, Success));



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/FeedbackSuccess/index.js